import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import Toast from '../../Toast/Toast';
import { v4 as uuidv4 } from 'uuid';
import './MultiApiSearch.css';

import axios from 'axios';

const MultiApiSearch = (props) => {
  const [searchText, setSearchText] = useState('');
  const [apiResponses, setApiResponses] = useState(props.value ? props.value : []);
  const [classInput, setClassInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    props.onChange(props.name, apiResponses);
  }, [apiResponses]);

  const verifyApiErrors = (apiResponses) => {
    if (apiResponses.status == 200) {
      if (apiResponses.data.length == 0) {
        Toast.error(`Não foi possível encontrar nenhum dado.`);
        return false
      }
      return true
    } else if (apiResponses.status == 404) {
      Toast.error(`Não foi possível encontrar nenhum dado.`);
    } else {
      Toast.error(`Não foi possível conectar na API.`);
    }

    return false
  }


  const searchApi = async () => {
    // INPUT CLASS IF CONTENT NOT EXISTS
    if (!searchText && props.required_input_search) {
      setClassInput('is-invalid')
      setIsLoading(false)
      return
    } else {
      setClassInput('')
    }

    // REQUEST
    const axiosOptions = {}
    if (props.endpoint_filter) {
      axiosOptions.data = {
        [props.endpoint_filter]: searchText
      }
    }

    setIsLoading(true)
    const searchResponse = await axios({
      method: props.endpoint_method,
      url: props.endpoint,
      ...axiosOptions,
    })
    // END REQUEST

    // VERIFY REQUEST RESPONSE
    if (!verifyApiErrors(searchResponse)) {
      setIsLoading(false)
      return
    }

    // SET DATA ON TABLE AND UPDATE STATE
    let stateResponses = [...apiResponses]

    if (eval(props.response_type == 'single')) {
      const responseToAdd = eval(`searchResponse.data${props.value_path && "." + props.value_path}`)

      const uniqueId = uuidv4();
      responseToAdd.uniqueId = uniqueId

      stateResponses.push(responseToAdd)
    } else {
      for (const response of eval(`searchResponse.data${props.value_path && "." + props.value_path}`)) {
        const uniqueId = uuidv4();
        response.uniqueId = uniqueId

        stateResponses.push(response)
      }
    }

    setApiResponses(stateResponses)
    setIsLoading(false)
  }

  const clickRemove = (uniqueId) => {
    const responsesBeforeRemove = apiResponses.filter(response => response.uniqueId != uniqueId)

    setApiResponses(responsesBeforeRemove)
  }

  return (
    <div>
      {!props.disabled && (
        <div className="d-flex">
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Digite sua pesquisa"
            className={`form-control col-4 w-50 ${classInput}`}
          />
          <button type="button" className="ml-2 btn btn-primary" onClick={searchApi} disabled={isLoading}>
            {isLoading ? (
              <FontAwesomeIcon className="loading-icon" icon={faSpinner} />
            ) : props.titleButton}
          </button>
        </div>
      )}
      <table className="api-table">
        <thead>
          <tr>
            <th>{props.label_column}</th>
            {!props.disabled && (
              <th>Excluir</th>
            )}
          </tr>
        </thead>
        <tbody>
          {apiResponses.map((apiResponse) => {
            return (
              <tr>
                <td>{eval(`apiResponse${props.label_path && "." + props.label_path}`)}</td>
                {!props.disabled && (
                  <td width={'20px'} style={{ textAlign: 'center' }}>
                    <button
                      type="button"
                      onClick={() => clickRemove(apiResponse.uniqueId)}
                      className="delete-button"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
      {props.error && (
        <span
          className="error invalid-feedback"
          style={{ display: 'inline' }}>
          {props.error}
        </span>
      )}
    </div>
  );
};

MultiApiSearch.defaultProps = {
  titleButton: 'Buscar',
  disabled: false
};

export default MultiApiSearch;